import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import AddEmployeeCommute from "./AddEmployeeCommute";
import ViewEmployeeCommute from "./ViewEmployeeCommute";
import { get, del } from "../../../utils/api";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterModal from "../../../Components/Common/FilterModal";
import Cards from "../../../Components/Common/Cards";
import ViewTable from "../../../Components/Common/ViewTable";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../utils/formatNumber";
import { useUser } from "../../../context/AuthContext";
import {
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
  mapTableDataWithFacility,
} from "../../../utils/facilityColumn";
import uploadicon from "../../../assets/images/uploadicon.svg";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const EmployeeCommute = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "asc",
  });

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    industrialProcess: [],
    equipmentType: [],
    industrialEquipment: [],
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isShortContent, setIsShortContent] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});

  const [cardData, setCardData] = useState({
    totalEmployees: 0,
    vehicleProprtion: [],
    averageDistanceCovered: 0,
  });
  const tableContainerRef = useRef(null);
  const [filterCountry, setFilterCountry] = useState([]);
  const [filterState, setFilterState] = useState([]);
  const [filterVehicleOwnership, setFilterVehicleOwnership] = useState([]);
  const [filterVehicle, setFilterVehicle] = useState([]);
  const [filterModeOfTransportation, setFilterModeOfTransportation] = useState(
    [],
  );
  const [dataforView, setdataForView] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const fetchExcelData = async () => {
    let arr = [];
    arr.push({
      "S no.": 1,
      "Employee ID": "",
      "Month Year (in 01/25 or Jan-25)": "",
      "Full Name": "",
      "Company Name": user?.company?.companyName,
      Country: user?.company?.country,
      State: "",
      "Reporting office Postal code (optional)": "",
      "Vehicle Type (Company/Personal)": "",
      "Employee Correspondence address (optional)": "",
      "Correspondence Postal code (optional)": "",
      "Reporting Office / facility address": user?.facility?.address,
      "Vendor name (optional)": "",
      "Usual mode of transportation (Road, Rail)": "",
      "Type of vehicle used (2-wheeler, 4-wheeler, Bus, Train, Metro)": "",
      "Vehicle Model (optional)": "",
      "Vehicle Fuel type (Petrol, Diesel, Electricity)": "",
      "Average fuel efficiency of vehicle (in km/l)": "",
      "Average distance covered 1-way (in km)": "",
      "Days of travel in a month": "",
    });
    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const headers = withFacilityViewTableHeader(
    [
      { key: "createdAt", label: "Date", sortable: true, width: "15%" },
      {
        key: "month",
        label: "Commute Month",
        sortable: true,
        width: "13%",
      },
      { key: "employeeId", label: "Employee Id", sortable: true, width: "15%" },

      {
        key: "fullName",
        label: "Full Name",
        sortable: true,
        width: "15%",
      },
      {
        key: "modeOfTransportation",
        label: "Mode Of Transportation",
        sortable: true,
        width: "16%",
      },
      {
        key: "vehicleType",
        label: "Type of Vehicle",
        sortable: true,
        width: "15%",
      },
      {
        key: "averageDistanceOneWay",
        label: "Distance Covered (1 Way)",
        sortable: true,
        truncate: true,
        width: "15%",
      },
      // { key: "fuelType", label: "Fuel Type", sortable: true },
      // { key: "fuelConsumed", label: "Fuel Consumed(Liters) ", sortable: true },
    ],
    showFacilityColumn,
  );

  const inputData = [
    {
      fieldName: "month",
      title: "Commute Month",
    },
    {
      fieldName: "employeeId",
      title: "Employee Id",
    },
    {
      fieldName: "fullName",
      title: "Full Name",
    },
    {
      fieldName: "country",
      title: "Country",
    },
    {
      fieldName: "state",
      title: "State",
    },
    {
      fieldName: "modeOfTransportation",
      title: "Mode Of Transportation",
    },
    {
      fieldName: "averageDistanceOneWay",
      title: "Distance Covered (1 Way)",
    },
    {
      fieldName: "daysWorked",
      title: "Travel Days",
    },
    {
      fieldName: "averageFuelEfficiency",
      title: "Average fuel efficiency",
    },
    {
      fieldName: "correspondenceAddress",
      title: "Correspondence Address",
    },
    {
      fieldName: "correspondencePostalCode",
      title: "Correspondence PostalCode",
    },
    {
      fieldName: "reportingOfficePostalCode",
      title: "Reporting Office PostalCode",
    },
    {
      fieldName: "reportingOfficeAddress",
      title: "Reporting Office Address",
    },
    {
      fieldName: "vehicleFuelType",
      title: "Fuel Type",
    },
    {
      fieldName: "vehicleModel",
      title: "Vehicle Model",
    },
    {
      fieldName: "vehicleOwnership",
      title: "Vehicle  Ownership",
    },
    {
      fieldName: "vehicleType",
      title: "Vehicle Type",
    },
    {
      fieldName: "vendorName",
      title: "Vendor Name",
    },
  ];

  const handleEdit = (data) => {
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    setView(true);
    setAddData(false);
    setdataForView(data);
  };

  const handleDelete = (index) => {
    setDeleteDialog(true);
    setdataView(index.id);
  };

  const handleDeleteAggree = async () => {
    await del(`/scope3/employeeCommute/delete?Id=${dataView}`)
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        fetchCardData();
      })
      .catch((err) => {
        console.log(err);
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };
  const isFilterApplied = Object.keys(filterObj).some(
    (key) =>
      filterObj[key] &&
      (Array.isArray(filterObj[key])
        ? filterObj[key].length > 0
        : filterObj[key]),
  );

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
  ) => {
    // const fetchData = async (filters = {}) => {
    let filter = { ...filterObj };
    // console.log("filtersort", filter);
    if (filter.createdAt?.start) {
      filter.startDate = filter.createdAt.start;
    }
    if (filter.createdAt?.end) {
      filter.endDate = filter.createdAt.end;
    }

    if (filter.consumptionPeriod?.start) {
      filter.startMonth = filter.consumptionPeriod.start;
    }
    if (filter.consumptionPeriod?.end) {
      filter.endMonth = filter.consumptionPeriod.end;
    }
    try {
      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();
      console.log("filtersort", queryParams, filters); // Debugging line
      const response = await get(
        `/scope3/employeeCommute/getAllEmployeeCommute?${queryParams}`,
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          fullName: item?.fullName,
          vehicleType: item?.vehicleType,
          modeOfTransportation: item.modeOfTransportation,
          averageDistanceOneWay: item.averageDistanceOneWay,
          state: item.state,
          country: item.country,
          employeeId: item.employeeId,

          action: "View",
          id: item?._id,
          ...item,
        };
      });
      setTableData(arr);
      setPageSize(response.data.totalPages);
      setTotalPages(response.data.totalPages);

      setPetroleums(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      //   const uniqueValues = await fetchUniqueValues();
      //   setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(filtersToApply);
    // fetchData()
  }, [currentPage, page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/employeeCommute/cardData`);
      setCardData({
        totalEmployees: res?.data?.data?.totalEmployees,
        vehicleProprtion: res?.data?.data?.totalVehicleOwnership,
        averageDistanceCovered: res?.data?.data?.averageDistanceCovered,
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  // Applying selected filter
  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj]);

  const fetchFilters = async () => {
    await get(`/scope3/employeeCommute/filter`)
      .then((res) => {
        setFilterCountry(res?.data?.data?.country);
        setFilterState(res?.data?.data?.state);
        setFilterVehicleOwnership(res?.data?.data.vehicleOwnership);
        setFilterModeOfTransportation(res?.data?.data.modeOfTransportation);
        setFilterVehicle(res?.data?.data?.vehicleType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Commute Month",
      type: "month",
      key: "consumptionPeriod",
      value: [],
    },
    { title: "Country", type: "option", key: "country", value: filterCountry },
    {
      title: "State",
      type: "option",
      key: "state",
      value: filterState,
    },
    // {
    //   title: "Company Provided/ Personal Vehicle",
    //   type: "option",
    //   key: "vehicleOwnership",
    //   value: filterVehicleOwnership,
    // },
    {
      title: "Transportation Mode",
      type: "option",
      key: "modeOfTransportation",
      value: ["Rail", "Road"],
    },
    {
      title: "Vehicle Type",
      type: "option",
      key: "vehicleOwnership",
      value: ["Company", "Personal"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };
  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };
  let bannerData = [
    {
      title: "Total number of employees availing company transportation",
      description: cardData?.totalEmployees ?? 0,
    },
    {
      title: "Average Distance Covered",
      description: `${formatNumber(cardData?.averageDistanceCovered) ?? 0} km`,
    },
    {
      title: "Vehicle Proportion used by Employees",
      description: null,
      chartData: [
        cardData?.vehicleProprtion?.find((item) => item._id === "Company")
          ?.count ?? 0,
        cardData?.vehicleProprtion?.find((item) => item._id === "Personal")
          ?.count || 0,
      ],
      labels: ["one", "two"],
      backgroundColors: ["#FF6384", "#36A2EB"],
      key: "employeeCommute",
    },
  ];

  const handleSelectChange = (value) => {
    // setSelectedValue(value);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
    fetchCardData();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <AddEmployeeCommute
        addData={addData}
        setAddData={setAddData}
        // SelectedData={dataView}
        fetchData={fetchData}
        fetchCardData={fetchCardData}
        // inputData={inputData}
        // addUrl={`${api}/scope3/roadTransportation/add`}
        // updateUrl={`${api}/scope3/roadTransportation/update`}
        //  setsnackOpen={setsnackOpen}
      />

      <ViewEmployeeCommute
        // id={element ? element._id : ""}
        data={dataforView}
        title={"Employee Commute Details"}
        viewData={view}
        setViewData={setView}
        inputData={inputData}
        handleEdit={handleEdit}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* <Box sx={{ margin: "0% 13% -3% 3%" }}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: 2,
            margin: "5% 55% 0% 22%",
          }}
        ></Box>
      </Box> */}
      <Cards
        data={bannerData}
        title={"Employee Commute"}
        onFilterChange={handleSelectChange}
      />
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          margin: "1rem",
          gap: "1rem",
        }}
      ></div> */}
      {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this Employee Commute record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: user?.companyAdmin ? "flex-end" : "space-between",
          alignItems: "center",
          margin: "2rem 0 1rem 0",
          gap: "1rem",
        }}
      >
        {user?.companyAdmin ? null : (
          <Button
            variant="contained"
            onClick={() => {
              setBulkUploadModal(true);
            }}
            endIcon={<img src={uploadicon} alt="upload" />}
            sx={{
              backgroundColor: "#fff",
              fontSize: "16px",
              textTransform: "none",
              color: "rgba(28, 72, 107, 1)",
              fontFamily: "Inter",
              fontWeight: "500",
              "&:hover": {
                backgroundColor: "#fff",
                opacity: 0.9,
              },
            }}
          >
            Upload
          </Button>
        )}

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#ffffff",
            textTransform: "none",
            fontSize: "16px",
            fontFamily: "Inter",
            fontWeight: "500",
            color: "black",
            "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
            "&:hover .dot-icon": { color: "#FFFFFF" },
          }}
          onClick={() => setIsFilterModalOpen(true)}
        >
          Filter <FilterListIcon sx={{ marginLeft: "0.5rem" }} />
          {isFilterApplied && (
            <FiberManualRecordIcon
              className="dot-icon"
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#488257",
                marginLeft: "5px",
                fontFamily: "Inter",
                textTransform: "none",
              }}
            />
          )}
        </Button>
      </div>

      <ViewTable
        tableContainerRef={tableContainerRef}
        isShortContent={isShortContent}
        headers={headers}
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        title={"Employee Commute"}
        onSort={handleSort}
        sortConfig={sortConfig}
        totalPages={totalPages}
        page={currentPage}
        count={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
        onView={handleView}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        // onEdit={handleEdit}
        onDelete={handleDelete}
      />
      {/* {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )} */}
      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          setsnackOpen={setsnackOpen}
          fileName={"Employee Commute"}
          url={"/scope3/employeeCommute/uploadEmployee"}
        />
      )}
    </Box>
  );
};

export default EmployeeCommute;
